


















































































import Vue, { PropType } from "vue";
import { Tewerkstellingsgegevens } from "../../types/NBE/Tewerkstellingsgegevens";
import { TewerkstellingsStatus } from "../../types/NBE/TewerkstellingsStatus";
import { TewerkstellingsTypes } from "../../types/NBE/TewerkstellingTypes";
import ListItem from "../interface/ListItem.vue";
import ListItemFile from "../interface/ListItemFile.vue";
export default Vue.extend({
  components: { ListItem, ListItemFile },
  props: {
    tewerkstellingen: {
      type: Array as PropType<Array<Tewerkstellingsgegevens>>,
    },
    toestemmingHo: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    isOnbezoldigdeOnderbreking(onderbreking: Tewerkstellingsgegevens): boolean {
      return (
        onderbreking.tewerkstellingsType == TewerkstellingsTypes.Onbezoldigd
      );
    },
    statusStringForOnderbreking(onderbreking: Tewerkstellingsgegevens): string {
      if (onderbreking.status == TewerkstellingsStatus.Accepted) {
        return "Goedgekeurd";
      }
      if (onderbreking.status == TewerkstellingsStatus.Rejected) {
        return "Geweigerd";
      }
      if (onderbreking.status == TewerkstellingsStatus.InProgress) {
        return "In behandeling";
      }
      if (onderbreking.status == TewerkstellingsStatus.NeedsChange) {
        return "Aanpassing nodig";
      }
      return "Onbekend";
    },
    textClassForOnderbrekingStatus(
      onderbreking: Tewerkstellingsgegevens
    ): string {
      if (onderbreking.status == TewerkstellingsStatus.Accepted) {
        return "text-success";
      }
      if (onderbreking.status == TewerkstellingsStatus.Rejected) {
        return "text-danger";
      }
      if (onderbreking.status == TewerkstellingsStatus.InProgress) {
        return "text-primary";
      }
      if (onderbreking.status == TewerkstellingsStatus.NeedsChange) {
        return "text-warning";
      }
      return "text-primary";
    },
    hasAny(array: Tewerkstellingsgegevens[]): boolean {
      return array.length > 0;
    },
  },
  computed: {},
});
